__turbopack_context__.v({
  "band": "DashboardShowtime-module-scss-module__lr1Z6a__band",
  "eventImage": "DashboardShowtime-module-scss-module__lr1Z6a__eventImage",
  "preview": "DashboardShowtime-module-scss-module__lr1Z6a__preview",
  "tile": "DashboardShowtime-module-scss-module__lr1Z6a__tile",
  "tiles": "DashboardShowtime-module-scss-module__lr1Z6a__tiles",
});
